import React from 'react';

import { Box, SxProps, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useRouter } from 'next/router';
import FunnelFooterV2 from 'src/components/Footer/FunnelFooterV2';
import { FUNNEL_PATH_NAMES } from 'src/utils/constants';

import Footer from '../Footer';
import NavBarHeader from '../NavBarHeader';
import FunnelNavBarHeader from '../NavBarHeader/FunnelNavBarHeader';

interface LayoutProps {
  isShowingCart?: boolean;
  children: React.ReactNode;
  hideHeader?: boolean;
  hideFooter?: boolean;
  isFunnelPage?: boolean;
  bottomSection?: React.ReactNode;
  cssOverrides?: SxProps<Theme>;
  contentCssOverrides?: SxProps<Theme>;
}

/**
 * Reusable Layout component.
 *
 * Should wrap most if not all pages.
 */
const Layout: React.FC<LayoutProps> = ({
  children,
  isShowingCart = false,
  bottomSection,
  isFunnelPage: isFunnelPageParam,
  hideHeader,
  hideFooter,
  cssOverrides,
  contentCssOverrides,
}) => {
  const theme = useTheme();
  const router = useRouter();
  const isFunnelPage =
    isFunnelPageParam ?? FUNNEL_PATH_NAMES.includes(router.pathname);

  return (
    <Box
      className="app-container"
      sx={[
        {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          backgroundColor: theme.palette.grey[50],
          minHeight: '100%',
        },
        ...(Array.isArray(cssOverrides) ? cssOverrides : [cssOverrides]),
      ]}
    >
      <Box>
        {hideHeader ? null : isFunnelPage ? (
          <FunnelNavBarHeader />
        ) : (
          <NavBarHeader />
        )}
        <Box
          sx={[
            {
              maxWidth: theme.breakpoints.values.contentMaxWidth,
              margin: 'auto',
              paddingBottom: '5rem',
              backgroundColor: theme.palette.grey[50],
            },
            ...(Array.isArray(contentCssOverrides)
              ? contentCssOverrides
              : [contentCssOverrides]),
          ]}
        >
          {children}
        </Box>
      </Box>
      <Box>
        {bottomSection}

        {/* Check out when this rendering changes. I don't see anyone actually
        using the hideFooter prop */}
        {hideFooter ? null : isFunnelPage ? (
          <FunnelFooterV2 isShowingCart={isShowingCart} />
        ) : (
          <Footer isShowingCart={isShowingCart} />
        )}
      </Box>
    </Box>
  );
};

export default Layout;
